import { jsxs, jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { AnalyticsId, IconSize } from "../../constants.js";
import { useHover } from "../../hooks/useHover.js";
import { palette } from "../../theme/palette.js";
import { I as Icon } from "../../Icon.js";
import Undo from "../Icons/Undo.js";
import X from "../Icons/X.js";
import styles from "./styles.module.scss";
var ChipSize = /* @__PURE__ */ ((ChipSize2) => {
  ChipSize2["medium"] = "medium";
  ChipSize2["large"] = "large";
  return ChipSize2;
})(ChipSize || {});
var ChipAction = /* @__PURE__ */ ((ChipAction2) => {
  ChipAction2["remove"] = "remove";
  ChipAction2["undo"] = "undo";
  return ChipAction2;
})(ChipAction || {});
var ChipVariant = /* @__PURE__ */ ((ChipVariant2) => {
  ChipVariant2["normal"] = "normal";
  ChipVariant2["oncolor"] = "oncolor";
  ChipVariant2["emphasised"] = "emphasised";
  return ChipVariant2;
})(ChipVariant || {});
const Chip = (props) => {
  const { children, size = "medium", color = "blueberry", variant = "normal", action, onClick, testId } = props;
  const { hoverRef, isHovered } = useHover();
  const chipClasses = classNames(styles.chip, styles[`chip--${size}`], styles[`chip--${color}`], styles[`chip--${variant}`], {
    [styles[`chip--undo`]]: action === "undo"
  });
  const getActionIcon = () => {
    switch (action) {
      case "undo":
        return Undo;
      case "remove":
        return X;
    }
  };
  return /* @__PURE__ */ jsxs("button", { className: chipClasses, onClick, ref: hoverRef, type: "button", "data-testid": testId, "data-analyticsid": AnalyticsId.Tag, children: [
    children,
    /* @__PURE__ */ jsx(Icon, { svgIcon: getActionIcon(), size: IconSize.XXSmall, color: palette[`${color}800`], isHovered })
  ] });
};
export {
  ChipAction,
  ChipSize,
  ChipVariant,
  Chip as default
};
//# sourceMappingURL=index.js.map
